import { createAction } from "@redux/actions/actionCreators";

const [useRemoveQueryFilter, removeQueryFilter] = createAction<{ filterId: string }>(
  "search/removeQueryFilter"
);

export default useRemoveQueryFilter;
export { removeQueryFilter };
